import { always } from 'ramda';

export const isInBrowser = always(typeof document !== 'undefined');
